<template>
  <div class="elasticacheResourceSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticache:elastiCacheResourceMemcached:page'
          ]"
          @click="search()"
          >{{ $t("alarms.common.search") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../../utils/cookieUtil.js";
import TableElastiCacheResourceMemcached from "./TableElastiCacheResourceMemcached";
var tableElasticacheResourceMemcached = TableElastiCacheResourceMemcached;
export default {
  name: "ElasticacheResourceMemcachedSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountName: ""
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    } else {
      //   tableElasticacheResourceMemcached.methods.showAll();
    }
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
          this.companyId = this.companyList[0].id;
          //   tableElasticacheResourceMemcached.methods.showAll();
        });
    },
    search: function() {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("accountName", this.accountName);
      eventBus.$emit("companyId", this.companyId);
      tableElasticacheResourceMemcached.methods.showAll();
    }
  }
};
</script>
<style scoped>
.elasticacheResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elasticache/memcached/ElastiCacheResourceMemcachedSearch.vue